import { ExportAPI } from '@chancenwerk/master-data-management/users/api/ExportAPI.js';
import { RegisterAPI } from '@chancenwerk/master-data-management/users/api/RegisterAPI.js';
import {
  getCountUsersByFilter,
  subscribeCountUsersByFilter,
  subscribeUsersByFilter,
  subscribeUsersByFilterExport,
} from '@chancenwerk/master-data-management/users/api/subscribeUsersByFilter.js';

export namespace UserAPI {
  export const subscribeByFilter = subscribeUsersByFilter;
  export const subscribeByFilterExport = subscribeUsersByFilterExport;
  export const subscribeCountByFilter = subscribeCountUsersByFilter;
  export const getCountByFilter = getCountUsersByFilter;

  export const exports = ExportAPI;
  export const register = RegisterAPI;
}
